import { render } from "./Info.vue?vue&type=template&id=003b6f1a&scoped=true"
import script from "./Info.vue?vue&type=script&lang=js"
export * from "./Info.vue?vue&type=script&lang=js"

import "./Info.vue?vue&type=style&index=0&id=003b6f1a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-003b6f1a"

export default script